import React from 'react';

const ITEMS = [
  '🚗 Boka körlektion online hos Alfa Trafikskola i Kista',
  '✅ Certifierade instruktörer – Abubakar & Ahmed',
  '🎯 10 lektioner för 7 500 kr',
  '⚠️ Riskutbildning Del 1: 499 kr – obligatorisk',
  '🌧️ Riskutbildning Del 2 (halkbana): 1 990 kr',
  '📞 Abubakar: 073-754 74 05 · Ahmed: 070-481 57 43',
  '📍 Nordkapsgatan 8 Tr, Kista',
  '📖 Teorilektioner & Gratis Teoriprov online',
];

export default function NewsTicker() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-gray-900 text-white h-9 flex items-center overflow-hidden text-xs" role="marquee">
      <span className="shrink-0 bg-red-600 text-white font-display font-black uppercase tracking-widest px-5 h-full flex items-center text-sm">ALFA</span>
      <div className="overflow-hidden flex-1">
        <div className="ticker-track flex whitespace-nowrap">
          {doubled.map((item, i) => (
            <span key={i} className="px-7 opacity-80 font-medium shrink-0">
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
